import React, { useEffect, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";
import Modal from "components/ui/modal";
import ProductLineSelectionModal from "./product-line-selection-modal";
import { OrderFormContext } from "./provider";

const ProductLineGate = ({ patientInfo }) => {
  const { setProductLine, patientHCPCHistory } = useContext(OrderFormContext);
  const [showModal, setShowModal] = useState(false);
  const history = useHistory();

  useEffect(() => {
    const productLines = patientInfo?.patient_product_lines ?? [];
    if (productLines.length > 1) {
      setShowModal(true);
    } else if (productLines.length === 1) {
      setProductLine(productLines[0].text);
    }
  }, [patientInfo, setProductLine]);

  if (showModal) {
    return (
      <Modal
        renderTrigger={() => null}
        renderContent={() => (
          <ProductLineSelectionModal
            open={showModal}
            productLines={patientInfo?.patient_product_lines ?? []}
            patientHCPCHistory={patientHCPCHistory}
            onSelect={line => {
              setShowModal(false);
              setProductLine(line.text);
            }}
            onClose={() => {
              setShowModal(false);
              history.push("/");
            }}
          />
        )}
        startOpen={showModal}
        onClose={() => {
          setShowModal(false);
          history.push("/");
        }}
      />
    );
  }
  return null;
};

export default ProductLineGate;

ProductLineGate.propTypes = {
  patientInfo: PropTypes.object.isRequired
};
